export const normalizeCurrencySymbol = (
  value?: string,
  targetSymbol: string = '$',
  symbolsToReplace: string[] = ['£']
): string | undefined => {
  if (value === undefined || value === null) {
    return value as unknown as undefined
  }
  let result = value
  for (const symbol of symbolsToReplace) {
    if (symbol && symbol !== targetSymbol) {
      result = result.split(symbol).join(targetSymbol)
    }
  }
  return result
}
